import { useState } from "react";
import { StandardButton } from "../../atoms/buttons";
import { Spinner } from "../../atoms/spinner";
import { TitleAtom } from "../../atoms/titleAtom";
import { ExpligoBadge } from "../expligobadge";
import { VerticalLayout } from "../layout";

export default function AssessmentStart({ elearningInformation, embedBtnState, startEmbedAssessment }) {
  const description = elearningInformation?.extra_description ? `${elearningInformation.extra_description}\n${elearningInformation.description || ""}` : elearningInformation?.description || "";
 
  return (
    <VerticalLayout className="complete-height dark-background">
      <img
        className="embed-background-image dark-background"
        src={elearningInformation.image_url || "/images/expligo_wp1.png"}
        alt={elearningInformation.title || "Cursus afbeelding"}
      />
      <div className="embed-background-overlay"></div>
      <div className="embed-thumbnail-bottom">
        <div className="bottom-text-container">
          <TitleAtom className={"bottom-text-title"} title={elearningInformation.title} />
          <CollapsibleText text={description} />
        </div>
        <StandardButton style={{ marginLeft:"auto",  }} backgroundColor="white" textColor="standard-text-color" onClick={startEmbedAssessment} className={"button-embedcourse"} isDisabled={embedBtnState === 1}>
          {embedBtnState === 1 ? <Spinner color="grey-900" size="1.5rem" /> : "Starten"}
        </StandardButton>
      </div>
      <ExpligoBadge />
    </VerticalLayout>
  );
};

const CollapsibleText = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  const paragraphs = text.split(/\n+/).filter((p) => p.trim().length > 0);
  const isCollapsible = paragraphs.length > 1;
  const displayText = expanded || !isCollapsible
    ? paragraphs.map((p, i) => <span key={i}>{p}<br /></span>)
    : <span>{paragraphs[0]}...</span>;

  return (
    <div style={{ maxHeight: "10rem", overflowY: "auto" }}>
      <p className="bottom-text-subtitle">
        {displayText} {isCollapsible && (
          <StandardButton
            style={{ width: "unset", height: "unset", padding: 0, display: "inline" }}
            backgroundColor="transparent"
            textColor="primary-500"
            onClick={() => setExpanded(!expanded)}
            className="leesmeer-button no-margin"
            title={expanded ? "Lees minder" : "Lees meer"}
          />
        )}
      </p>
    </div>
  );
};



